<div class="error">{{ labels()[0] }}</div>
<div class="warn">{{ labels()[1] }}</div>
<div class="ok">{{ labels()[2] }}</div>
<div class="warn">{{ labels()[3] }}</div>
<div class="error">{{ labels()[4] }}</div>
